module.exports = __webpack_public_path__ + "img/login-rejected.80b3048c.png";